// extracted by mini-css-extract-plugin
export default {"content":"AddCoefficientToActKC2_content__Mhjd0"};